const logUserAction = async (description) => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const email = userDetails?.email;
  const datetime = new Date().toISOString().replace("T", " ").slice(0, 19);

  const logData = {
    datetime,
    email,
    desc: description,
  };

  try {
    const response = await fetch(
      "https://api.bharatnet.sunshineiotronics.com/api/v2/logs/system",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(logData),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to log the action");
    }

    console.log("Log sent successfully");
  } catch (error) {
    console.error("Error sending log:", error);
  }
};

export default logUserAction;
